import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContinuingEducationComponent } from './continuing-education/continuing-education.component';
import { RouterModule, Routes } from '@angular/router';
import { TrainingEducationComponent } from './training-education/training-education.component';
import { MatCardModule } from '@angular/material/card';
import { OndemandTrainingComponent } from './ondemand-training/ondemand-training.component';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsUiModule } from '@cigna/shared/angular/analytics-ui';
import { UiIconModule } from '@cigna/shared/angular/icon-ui';
import { AuthenticationGuard } from '@cigna/cigna-for-brokers/shell/data-access';
import { CignaForBrokersLoginDataAccessModule } from '@cigna/cigna-for-brokers/login-data-access';

const routes: Routes = [
  {
    path: '',
    component: TrainingEducationComponent,
    canActivate: [AuthenticationGuard],
    data: { entitlementMenu: 'smenu-com-training' },
  },
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule.forChild(routes),
    MatCardModule,
    AnalyticsUiModule,
    UiIconModule,
    CignaForBrokersLoginDataAccessModule,
  ],
  declarations: [
    ContinuingEducationComponent,
    TrainingEducationComponent,
    OndemandTrainingComponent,
  ],
  providers: [TranslateModule],
})
export class CignaForBrokersTrainingEducationFeatureModule {}
